// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro seal_Timestamp_Level.
 */
enum EnumSealTimestampLevel {
    QUALIFIED = 'QUALIFIED', 
    GUARANTEED = 'GUARANTEED', 
    NONE = 'NONE'
};
export default EnumSealTimestampLevel;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSealTimestampLevel.QUALIFIED]: {caption: ''},
    [EnumSealTimestampLevel.GUARANTEED]: {caption: ''},
    [EnumSealTimestampLevel.NONE]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
